<template>
    <div class="container"> 
       <div class="is-size-2 top20">Manage Groups</div>
       <br>
       <div id="mainDiv" class="limitWidth">
           <table width="100%">
                <tr v-for="(item, i) in groups" :key="i" class="connectRow">
                    <td>&nbsp;{{item.name}}</td>
                    <td align="center"><button class="button is-small" @click="doDetail(item.id)">MANAGE</button></td>
                </tr>
           </table>
           <div class="lineDivider">&nbsp;</div>
       </div>
    
    </div>
</template>

<script>
import { AZEventBus } from '../components/AZEventBus'

export default {
    data: function () {
        return {
            groups: [],
            az: az,
            inited: false
        }
    },
    components: {

    },
    methods: {
        doDetail: function (id) {
             this.$router.push('groupdetail/' + id)
        }
    },
    mounted: function () {
        const self = this
        self.worked = function (data) {
             az.addRemSpinner(false, "id", "mainDiv")
            self.groups = data.r;
        }
        self.noWorked = function () {
             az.addRemSpinner(false, "id", "mainDiv")
            self.$root.app.showModalOK({message: 'There was en error loading groups'})
        }

        function init(){
            az.addRemSpinner(true, "id", "mainDiv")
            self.inited = true;
            self.$root.app.apiClient.get('auth/account/groups', {}, self.worked, self.noWorked)
        }

        if(self.$root.app.doneFederating){
            init();
        }

        AZEventBus.$once('onFederate', msg => {
        if(self.inited == false)
            init();
        });
    
    }
}
</script>